import React, { useState } from "react";
import { Application } from "@/api/applications";
import AddButton from "@/ui-controls/AddButton";
import RigthPanel from "@/ui-controls/RigthPanel";
import NewApplicationForm from "@/components/applications/NewApplicationForm";

interface Props {
  onSave: (application: Application) => any;
  disabled?: boolean;
}

const NewApplication = (props: Props) => {
  const openPanel = () => {
    setIPanelOpen(true);
  };

  const onCloseNewAppPanel = () => {
    setIPanelOpen(false);
  };

  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  return (
    <>
      <AddButton text="Application" onClick={openPanel} disabled={props.disabled} />
      <RigthPanel
        header="Add New Application"
        isOpen={isPanelOpen}
        dismissPanel={onCloseNewAppPanel}
        childComponent={NewApplicationForm}
        childProps={{
          onClose: () => onCloseNewAppPanel(),
          onSave: (app: Application) => {
            props.onSave(app);
            onCloseNewAppPanel();
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default NewApplication;
